import React, { useState, useEffect, useCallback } from 'react';
import { db, storage } from '../../firebase';
import { collection, getDocs, addDoc, deleteDoc, doc, serverTimestamp, query, orderBy } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';
import { X } from 'lucide-react';

const ManageGallery = () => {
    const [gallery, setGallery] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const fetchGallery = useCallback(async () => {
        const galleryCollectionRef = collection(db, "gallery");
        const q = query(galleryCollectionRef, orderBy("createdAt", "desc"));
        const data = await getDocs(q);
        setGallery(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    }, []);

    useEffect(() => {
        fetchGallery();
    }, [fetchGallery]);

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setIsUploading(true);
        const imageRef = ref(storage, `gallery/${file.name + uuidv4()}`);

        try {
            const snapshot = await uploadBytes(imageRef, file);
            const url = await getDownloadURL(snapshot.ref);
            
            const galleryCollectionRef = collection(db, "gallery");
            await addDoc(galleryCollectionRef, { 
                url: url, 
                storagePath: snapshot.ref.fullPath,
                createdAt: serverTimestamp() 
            });
            
            fetchGallery();
        } catch (error) {
            console.error("Erro no upload:", error);
            alert("Falha ao enviar imagem.");
        } finally {
            setIsUploading(false);
        }
    };

    const handleDelete = async (image) => {
        if (window.confirm("Tem certeza que deseja excluir esta imagem? A ação não pode ser desfeita.")) {
            const imageDoc = doc(db, "gallery", image.id);
            const imageRef = ref(storage, image.storagePath);

            try {
                await deleteObject(imageRef);
                await deleteDoc(imageDoc);
                fetchGallery();
            } catch (error) {
                console.error("Erro ao excluir imagem:", error);
                alert("Falha ao excluir imagem.");
                await deleteDoc(imageDoc);
                fetchGallery();
            }
        }
    };

    return (
        <div className="bg-neutral-800 p-6 rounded-lg mb-8">
            <h2 className="text-xl font-bold text-white mb-4">Gerenciar Galeria</h2>
            <div className="mb-4">
                <label htmlFor="gallery-upload" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-500 cursor-pointer">
                    {isUploading ? 'Enviando...' : 'Adicionar Nova Imagem'}
                </label>
                <input id="gallery-upload" type="file" onChange={handleImageUpload} disabled={isUploading} className="hidden" />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                {gallery.map(image => (
                    <div key={image.id} className="relative group">
                        <img src={image.url} alt="Galeria" className="w-full h-40 object-cover rounded-lg" />
                        <button onClick={() => handleDelete(image)} className="absolute top-1 right-1 bg-red-600 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity">
                            <X size={16} />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ManageGallery;
